$(function () {
	$('#legal_agreement_checked').click(function(){
		$('#CB_form,.smcx-show').toggleClass("agree");
		$('#legal_disagreement_checked').prop('checked',false);
	})
	$('#legal_agreement_checked_2').click(function(){ 
		$('.smcx-show_2').toggleClass("agree"); 
		$('#legal_disagreement_checked_2').prop('checked',false); 
	})
	$('#legal_agreement_checked_3').click(function(){ 
		$('.smcx-show_3').toggleClass("agree"); 
		$('#legal_disagreement_checked_3').prop('checked',false); 
	})

	$('#legal_disagreement_checked').click(function(){
		$('#legal_agreement_checked').prop('checked',false);
		window.location.href = '/contact/';
	})

	$('#submit_button').on('click',function(){
		if ( $("#legal_agreement_checked").prop('checked') === true ) {
			$("#mailform").submit();
		} else {
			location.href="#legal_agreement";
			alert('個人情報保護方針にご同意ください。');
			return false;
		}
	});	
	
});

window.onload = function(){
	if($("#legal_agreement_checked").prop('checked')) {
		$('#CB_form,.smcx-show').addClass("agree");
	}
	if($("#legal_agreement_checked_2").prop('checked')) {
		$('.smcx-show_2').addClass("agree");
	}
	if($("#legal_agreement_checked_3").prop('checked')) {
		$('.smcx-show_3').addClass("agree");
	}
};
